module.exports = __webpack_public_path__ + "static/lampenschirm_1.746f55c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/lampenschirm_1.jpg
// module id = 559
// module chunks = 35783957827783